import React from 'react';
import { Bounce as Rotate, Slide } from 'react-reveal';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import Crumb from '../utils/Crumb';

const Contact = () => {
  return (
    <div>
      <Header />
      <Crumb title="Contact Us" slogan="Lorem Ipsum Dollar Sir Met" />
      <section>
        <div className="container my-5 pt-5">
          <div className="row">
            <div className="col-lg-6 py-5">
              <div className="py-5">
                <h1 className="font-weight-bold about_section my-4">Office Address</h1>
                <Rotate right cascade>
                <h5 className="d-flex align-items-center my-5">
                  <div className="footer_heading font-weight-bolder d-inline-block mr-4 h2">@</div>
                  <div className="font-weight-bold footer_link">UDAY Tower, 4th Floor, 57 Gulshan Ave, <br/> Dhaka, Bangladesh</div>
                </h5>
                <h5 className="d-flex align-items-center my-4">
                  <div className="footer_heading font-weight-bolder d-inline-block mr-4 h2">@</div>
                  <div className="font-weight-bold footer_link">+8802 9892393</div>
                </h5>
                <h5 className="d-flex align-items-center my-4">
                  <div className="footer_heading font-weight-bolder d-inline-block mr-4 h2">@</div>
                  <div className="font-weight-bold footer_link">info@docterio.com</div>
                </h5>
                </Rotate>
              </div>
            </div>
            <Slide right>
            <div className="col-lg-6">
              <iframe className="shadow" title="MAPS" src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d2300.021890368128!2d90.41675639152771!3d23.78098208357512!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sUDAY%20Tower%2C%204th%20Floor%2C%2057%20Gulshan%20Ave%2C%20Dhaka%2C%20Bangladesh!5e0!3m2!1sen!2s!4v1605466970022!5m2!1sen!2s" width="100%"style={{ height:"34rem" }} frameBorder="0"></iframe>
            </div>
            </Slide>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Contact;